var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F3FCEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 25.6562C37.1631 25.6562 34.3899 26.4975 32.031 28.0736C29.6722 29.6497 27.8338 31.8899 26.7481 34.5109C25.6625 37.1319 25.3784 40.0159 25.9319 42.7983C26.4853 45.5807 27.8514 48.1366 29.8574 50.1426C31.8635 52.1486 34.4193 53.5147 37.2017 54.0681C39.9841 54.6216 42.8681 54.3375 45.4891 53.2519C48.1101 52.1663 50.3503 50.3278 51.9264 47.969C53.5025 45.6101 54.3438 42.8369 54.3438 40C54.3395 36.1971 52.827 32.5512 50.1379 29.8621C47.4489 27.173 43.8029 25.6605 40 25.6562ZM40 51.1562C37.7935 51.1562 35.6366 50.5019 33.8019 49.2761C31.9673 48.0502 30.5374 46.3078 29.693 44.2693C28.8486 42.2308 28.6277 39.9876 29.0581 37.8235C29.4886 35.6594 30.5511 33.6716 32.1113 32.1113C33.6716 30.5511 35.6594 29.4886 37.8235 29.0581C39.9876 28.6276 42.2308 28.8486 44.2693 29.693C46.3079 30.5374 48.0502 31.9673 49.2761 33.8019C50.502 35.6366 51.1563 37.7935 51.1563 40C51.1531 42.9579 49.9767 45.7936 47.8852 47.8852C45.7937 49.9767 42.9579 51.1531 40 51.1562ZM49.0313 40C49.0313 40.4227 48.8633 40.8281 48.5645 41.127C48.2656 41.4258 47.8602 41.5938 47.4375 41.5938H40C39.5773 41.5938 39.1719 41.4258 38.8731 41.127C38.5742 40.8281 38.4063 40.4227 38.4063 40V32.5625C38.4063 32.1398 38.5742 31.7344 38.8731 31.4355C39.1719 31.1367 39.5773 30.9688 40 30.9688C40.4227 30.9688 40.8281 31.1367 41.127 31.4355C41.4258 31.7344 41.5938 32.1398 41.5938 32.5625V38.4062H47.4375C47.8602 38.4062 48.2656 38.5742 48.5645 38.873C48.8633 39.1719 49.0313 39.5773 49.0313 40Z",
    fill: "#7ED957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.521629a03c4cb10e8377412eb47fa202.svg";
export { ForwardRef as ReactComponent };